module.exports = __webpack_public_path__ + "img/points-btn.8a40e219.png";